import { Badge, type BadgeVariant } from '@/admin-design/_common'
import { cn } from '@/lib/utils'

// Container state → admin-design Badge variant.
// running=success / exited=destructive / paused=warning / created=muted
const stateVariant: Record<string, BadgeVariant> = {
  running: 'success',
  exited: 'destructive',
  paused: 'warning',
  created: 'muted',
}

// Dot color uses solid semantic tokens (not soft variants) for visibility
// against the badge's soft background. Mirrors the variant mapping.
const dotStyles: Record<string, string> = {
  running: 'bg-success',
  exited: 'bg-destructive',
  paused: 'bg-warning',
  created: 'bg-muted-foreground/40',
}

interface StatusBadgeProps {
  state: string
  className?: string
}

export default function StatusBadge({ state, className }: StatusBadgeProps) {
  const normalized = state.toLowerCase()
  const variant = stateVariant[normalized] ?? 'muted'
  return (
    <Badge variant={variant} className={cn('gap-1.5', className)}>
      <span
        className={cn(
          'w-1.5 h-1.5 rounded-full',
          dotStyles[normalized] ?? 'bg-muted-foreground/40',
        )}
      />
      {normalized}
    </Badge>
  )
}
